module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div'), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": _vm.PL_pl_approved_flag == 0 ? 'danger' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.PL_pl_approved_flag == 0 ? _vm.CommonPLPanel(_vm.PLPanelDetail) : ''
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.PL_is_pl_approved))])]), _c('br'), _vm._v(" "), (_vm.PL_pl_approved_flag == 1 && _vm.PL_pl_approved_remark) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.PL_pl_approved_remark)
    }
  }, [_vm._v(_vm._s(_vm.wordWrap(_vm.PL_pl_approved_remark, 24)))]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.PL_pl_approved_flag == 1 && _vm.PL_pl_approved_date) ? _c('span', [_vm._v(_vm._s(_vm.PL_pl_approved_date))]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "Common_modal-PL-conf",
    attrs: {
      "id": "Common_modal-PL-conf",
      "title": _vm.PL_title + _vm.PL_JOBNO,
      "size": "lg",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('label', {
    attrs: {
      "for": "ColumnName"
    }
  }, [_vm._v("Remark :")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mt-2"
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.PLPanelDetail.pl_approved_remark),
      callback: function($$v) {
        _vm.$set(_vm.PLPanelDetail, "pl_approved_remark", $$v)
      },
      expression: "PLPanelDetail.pl_approved_remark"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [(_vm.PLPanelDetail.pl_approved_remark) ? _c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "disabled": _vm.PLPanelDetail.pl_approved_remark && _vm.PLPanelDetail.lock_button ?
        false :
        !_vm.PLPanelDetail.pl_approved_remark && _vm.PLPanelDetail.lock_button ?
        true :
        false,
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.CommonConfLock
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-2",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.CommoncloseCommonPLPanelConfirm
    }
  }, [_vm._v("Close")])], 1)], 1)])]), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef300d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/plApprovalCom.vue
// module id = 2493
// module chunks = 0